/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { createConditionalNode } from '../../factoriesAny.js';
export var ConditionalNodeDependencies = {
  NodeDependencies: NodeDependencies,
  createConditionalNode: createConditionalNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesConditionalNode.generated.js
// module id = 492
// module chunks = 0